import { Grid, Typography } from '@mui/material';
import { ODSDivider } from '@telekom-ods/react-ui-kit';
import { type FC } from 'react';

import rbacCheck from '../../../rbac/rbacCheck';

import ApiKeyForm from './ApiKeyForm';
import CloudResetPassword from './CloudPasswordReset';
import UserPasswordChange from './UserPasswordChange';

import { useUserData } from '@/redux/selectors';

const Settings: FC = () => {
  const userData = useUserData();
  const canSeeChangeCloudPwd: boolean = rbacCheck(userData.roles, '/settings/cloud-reset-password') as boolean;

  return (
    <Grid
      container
      justifyContent='space-between'
      rowGap={2}
    >
      <Grid
        item
        xs={8}
      >
        <Typography
          variant='h4'
          color='primary'
        >
          API Key
        </Typography>
        <Typography variant='h6'>Generate Api Key:</Typography>
        <Typography>Issue an API-key to use in your automation.</Typography>
      </Grid>
      <Grid
        item
        xs={4}
      >
        <ApiKeyForm />
      </Grid>
      <Grid
        item
        xs={12}
      >
        <ODSDivider variant='horizontal' />
      </Grid>
      <Grid
        item
        xs={8}
      >
        <Typography
          variant='h4'
          color='primary'
        >
          User Password
        </Typography>
        <Typography variant='h6'>Change your password:</Typography>
      </Grid>
      <Grid
        item
        xs={4}
      >
        <UserPasswordChange />
      </Grid>
      <Grid
        item
        xs={12}
      >
        <ODSDivider variant='horizontal' />
      </Grid>
      {canSeeChangeCloudPwd && (
        <>
          <Grid
            item
            xs={8}
          >
            <Typography
              variant='h4'
              color='primary'
            >
              Cloud Password
            </Typography>
            <Typography variant='h6'>Change a cloud password:</Typography>
          </Grid>
          <Grid
            item
            xs={4}
          >
            <CloudResetPassword />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default Settings;
